import { useMutation } from 'react-query';

import { GAMFAInit } from '../../lib/api';

export function useMutateGaMfaInitiate() {
  return useMutation(GAMFAInit);
}
